module.exports = __webpack_public_path__ + "static/media/tubi.6bb83d27.png";